import * as React from "react";
import { KeyValue } from "../interfaces";
import { fetchData } from "../common/services/ApiClient";
import { ApiBaseUrl } from "../config";

export default function useLastYearFilter(
  filters: KeyValue,
  updateFilter: (filterField: string, value: string | number) => void,
  updateStartEndDate?: boolean,
) {
  const [lastYear, setLastYear] = React.useState<number>(0);
  React.useEffect(() => {
    if (!lastYear) {
      let isMounted = true;
      (async () => {
        await fetchData(
          `${ApiBaseUrl()}/sod?agg_by=YEAR&sort_by=YEAR&sort_order=desc&agg_limit=1`,
        )
          .then(response => {
            if (isMounted) {
              const year = response.data[0].YEAR;
              setLastYear(year);
              updateFilter(
                "lastYear",
                filters.lastYear ? filters.lastYear : year,
              );
              if (
                updateStartEndDate &&
                !filters.endDate &&
                !filters.startDate
              ) {
                updateFilter(
                  "startDate",
                  filters.lastYear ? filters.lastYear - 1 : year - 1,
                );
                updateFilter(
                  "endDate",
                  filters.lastYear ? filters.lastYear : year,
                );
              }
            }
          })
          .catch(error => {
            console.error(error);
          });
      })();
      return () => {
        isMounted = false;
      };
    }
  }, [
    filters.endDate,
    filters.lastYear,
    filters.startDate,
    lastYear,
    updateFilter,
    updateStartEndDate,
  ]);

  return { lastYear };
}
